/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PetTypeReferenceModel } from './PetTypeReferenceModel';
import {
    PetTypeReferenceModelFromJSON,
    PetTypeReferenceModelFromJSONTyped,
    PetTypeReferenceModelToJSON,
} from './PetTypeReferenceModel';

/**
 * 
 * @export
 * @interface PetAvatarModel
 */
export interface PetAvatarModel {
    /**
     * 
     * @type {number}
     * @memberof PetAvatarModel
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PetAvatarModel
     */
    imageUri?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PetAvatarModel
     */
    markForDelete?: boolean;
    /**
     * 
     * @type {PetTypeReferenceModel}
     * @memberof PetAvatarModel
     */
    type?: PetTypeReferenceModel;
}

/**
 * Check if a given object implements the PetAvatarModel interface.
 */
export function instanceOfPetAvatarModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PetAvatarModelFromJSON(json: any): PetAvatarModel {
    return PetAvatarModelFromJSONTyped(json, false);
}

export function PetAvatarModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetAvatarModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'imageUri': !exists(json, 'imageUri') ? undefined : json['imageUri'],
        'markForDelete': !exists(json, 'markForDelete') ? undefined : json['markForDelete'],
        'type': !exists(json, 'type') ? undefined : PetTypeReferenceModelFromJSON(json['type']),
    };
}

export function PetAvatarModelToJSON(value?: PetAvatarModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'imageUri': value.imageUri,
        'markForDelete': value.markForDelete,
        'type': PetTypeReferenceModelToJSON(value.type),
    };
}

